module.exports = __webpack_public_path__ + "img/04_kii_07.92b26a01.jpg";